export const doMain = process.env.NODE_ENV == 'production' ? 'ule.com' : 'beta.ule.com';
export const cdnDoMain = process.env.NODE_ENV == 'production' ? 'ulecdn.com' : 'beta.ulecdn.com';
// const doMain = 'ule.com';
console.log(process.env.NODE_ENV)
console.log(doMain)
export const datetime = '//pub.' + doMain + '/clock/datetime'; //获取系统时间
export const getActivityInfos = '//static-content.' + cdnDoMain + '/yxdcdn/act/redenvelopes/getActivityInfos/'; //获取活动场次
export const querySingCount = '//prize.' + doMain + '/mc/m/api/v3/base/sign/querySingCount'; //签到次数查询接口
export const signup = '//service.' + doMain + '/appact/signin/signup'; //签到接口
export const getIndexCookies = '//my.' + doMain + '/usr/getIndexCookies.do'; //获取cookie信息接口
export const getBatchActivityTimes = '//service.' + doMain + '/appact/redenvelopes/getBatchActivityTimes'; //获取下单赢大奖模块抽奖资格

/*
   countUser 查询集卡活动参与人数
*/ 
export const countUser = '//service.' + doMain + '/appact/collectCard/countUser';

/*
   dwRecommond 商品广告推荐位
*/ 
export const dwrecommond= '//ustatic.ulecdn.com/mobilead/v2/recommend/dwRecommond/';


/*
   qryinfobyOwner 用户当天分享成单次数查询
*/ 
export const qryinfobyOwner= '//api.' + doMain + '/ylxdact/ylxd/act/collectCards/qryInfoByOwnerID.do';

/*
   getActivityTimes 抽奖资格查询
*/ 
export const getActivityTimes= '//service.' + doMain + '/appact/redenvelopes/getActivityTimes';

/*
   myCardInfos 查看用户获得的卡片
*/ 
export const myCardInfos= '//service.' + doMain + '/appact/collectCard/cards/myCardInfos';

/*
   queryUserCard 查看用户获得的卡片大卡
*/ 
export const queryUserCard= '//service.' + doMain + '/appact/collectCard/card/queryUserCard';

/*
   queryUserCard 翻卡抽奖
*/ 
export const turnOverTheCard= '//service.' + doMain + '/appact/collectCard/card/turnOverTheCard';

/*
   lottry 抽卡抽奖
*/ 
export const lottry= '//service.' + doMain + '/appact/redenvelopes/lottry';

/*
   combine 合成卡片接口
*/ 
export const combine= '//service.' + doMain + '/appact/collectCard/card/combine';

/*
   getLotteryServerTime 获取服务器时间
*/ 
export const getLotteryServerTime= '//prize.' + doMain + '/mc/base/lotteryUtils/getLotteryServerTime';


/*
   queryQualificationByRule 大网获取用户当天完成次数
*/ 
export const queryQualificationByRule= '//service.' + doMain + '/appact/promotion/queryQualificationByRule';

/*
  queryYxdTeamByOwnerIdForUle   查询用户是否加入战队   
*/
export const queryYxdTeamByOwnerIdForUle= '//api.' + doMain + '/ylxdact/ylxd/act/postpk/queryYxdTeamByOwnerIdForUle.do';

/*
   qryGiverInfo    查询战队成员信息
*/
export const qryGiverInfo= '//api.' + doMain + '/ylxdact/ylxd/act/collectCards/qryGiverInfo.do';

/*
   exChangeCards   增送卡片接口
*/
export const exChangeCards= '//api.' + doMain + '/ylxdact/ylxd/act/collectCards/exChangeCards.do';

/*
   qryReAndSendCardsHis   获取赠卡纪录
*/
export const qryReAndSendCardsHis= '//api.' + doMain + '/ylxdact/ylxd/act/collectCards/qryReAndSendCardsHis.do';



// WEBPACK FOOTER //
// ./src/assets/js/url.js